import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { uploadData, getUrl } from "@aws-amplify/storage";
import { fetchAuthSession, signOut } from "@aws-amplify/auth";
import { getLastUploadedData } from "../services/api";
import { useDispatch } from "react-redux"; // ✅ Import Redux dispatcher
import { uploadData as uploadToRedux } from "../app/dataActions"; // ✅ Import Redux action

const FileUploadPage = () => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [fileUrl, setFileUrl] = useState("");
  const [user, setUser] = useState(null);
  const [data, setData] = useState([]);
  const dispatch = useDispatch(); // ✅ Redux dispatch
  const navigate = useNavigate();

  const fixedFileKey = "uploads/latest-file.xlsx";

  useEffect(() => {
    fetchAuthSession()
      .then((session) => {
        if (session.tokens) {
          setUser(session.tokens);
          fetchFileUrl();
          fetchLatestData();
        } else {
          navigate("/login");
        }
      })
      .catch(() => navigate("/login"));
  }, []);

  const fetchFileUrl = async () => {
    try {
      const url = await getUrl({ key: fixedFileKey });
      setFileUrl(url);
    } catch (error) {
      console.error("Error fetching file URL:", error);
    }
  };

  const fetchLatestData = async () => {
    try {
      console.log("Fetching latest data...");
      const latestData = await getLastUploadedData();
      setData([...latestData.data]);

      // ✅ Dispatch new data to Redux
      dispatch(uploadToRedux(latestData.data));

    } catch (error) {
      console.error("Error fetching latest uploaded data:", error);
    }
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      alert("Please select a file first!");
      return;
    }

    setUploading(true);

    try {
      await uploadData({
        key: fixedFileKey,
        data: file,
        options: { accessLevel: "public" },
      });

      await fetchFileUrl();
      await fetchLatestData(); // ✅ Fetch latest data and update Redux

      alert("File uploaded successfully, refresh the page to see the updated data");
      // ✅ Force a page reload to refresh the data
     // window.location.href = "/file-uploader";
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Error uploading file");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ padding: "20px", maxWidth: "500px", margin: "auto" }}>
      <h2>Upload a File</h2>

      <input type="file" onChange={handleFileChange} />
      <button onClick={handleUpload} disabled={uploading}>
        {uploading ? "Uploading..." : "Upload"}
      </button>

      {data.length > 0 && (
        <div>
          <h3>Latest Uploaded Data:</h3>
          <pre>{JSON.stringify(data, null, 2)}</pre>
        </div>
      )}

      <button onClick={() => signOut().then(() => navigate("/login"))}>
        Logout
      </button>
    </div>
  );
};

export default FileUploadPage;
